import { ITelemetryItem } from '@microsoft/applicationinsights-web';

import { THIRD_PARTY_SCRIPT_ERROR_ORIGIN } from '../constants/error-origin.constants';
import { containsBrowserExtensionScheme } from './browser-extension-error.utils';
import { findOriginFrame, tagExceptionOrigin } from './exception-origin.utils';

const thirdPartyScriptHosts = ['scripts.clarity.ms', 'googletagmanager.com'];

export function isThirdPartyScriptStack(stack: string | null | undefined): boolean {
  if (typeof stack !== 'string') {
    return false;
  }
  return matchesThirdPartyScriptOrigin(findOriginFrame(stack));
}

export function tagThirdPartyScriptException(item: ITelemetryItem): void {
  tagExceptionOrigin(item, THIRD_PARTY_SCRIPT_ERROR_ORIGIN, matchesThirdPartyScriptOrigin, isThirdPartyScriptStack);
}

function matchesThirdPartyScriptOrigin(value: string): boolean {
  if (containsBrowserExtensionScheme(value)) {
    return false;
  }
  const host = /https?:\/\/([^/\s:)]+)/.exec(value)?.[1] ?? '';
  return thirdPartyScriptHosts.some((knownHost) => host === knownHost || host.endsWith(`.${knownHost}`));
}
